module.exports = __webpack_public_path__ + "img/http@2x.23b73c0e.png";